import { List } from "antd";
import { ListProps } from "antd/lib";
import { ListItemMetaProps, ListItemProps } from "antd/lib/list";
import styled from "styled-components";

export type AppListProps<T = any> = ListProps<T> & {
  padding?: string;
};

export type AppListItemProps = ListItemProps;
export type AppListItemMetaProps = ListItemMetaProps;

const StyledAppList = styled(List)<AppListProps>`
  width: 100%;
  max-width: 100%;
  padding: ${({ padding }) => padding || "0"};

  & .ant-list-items > div {
    &.ant-list-item-meta {
      display: flex;
      align-items: center;
      gap: 7px;

      .ant-list-item-meta-avatar {
        width: auto;
        min-width: 20px;
        min-height: 20px;
        line-height: 1.2;
        margin-right: 10px;

        [dir="rtl"] & {
          margin-right: 0;
          margin-left: 10px;
        }
      }

      .ant-list-item-meta-content {
        width: 100%;

        .ant-list-item-meta-title {
          margin-bottom: 0;
          line-height: 1.2;
          font-size: 14px;
          font-weight: 400;
          color: ${({ theme }) => theme.palette.text.secondary};
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
        }
      }
    }
  }
`;

export default function AppList<T = any>(props: AppListProps<T>) {
  return <StyledAppList {...props} />;
}

AppList.Item = List.Item;
